import gql from 'graphql-tag'


export const MYSHELF = gql`
    query userShelf($id: String!) {
        userShelf(id: $id) {
            id note
            user {
                id
            }
            product {
                id
                title
                url
                rating
                category {
                title
                }
            }
        }
    }
`

export const MYSHELVES = gql`
 query shelves($userId: String, $searchVal: String) {
    shelves(userId: $userId, searchVal: $searchVal) {
        id note
        user {
            id
        }
        product {
            id
            url
            title
            description
            rating
            category {
                title
            }
            reviews {
                rating
            }
        }
    }
 }
`

export const CREATE_MYSHELVES = gql`
    mutation createUserShelf($data: UserShelfInput) {
        createUserShelf(data: $data) {
            id
        }
    }
`

export const DELETE_MYSHELVES = gql`
    mutation deleteUserShelves($data: UserShelfInput) {
        deleteUserShelves(data: $data) 
    }
`